import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./containers/LandingPage";
function App() {
  return (
    <>
    <Router>
      <Routes>
        <Route exact path='/' element={<LandingPage />} />
        <Route path='*' element={<LandingPage />} />
      </Routes>
    </Router>
    </>
  )
}

export default App;
